/**
 * 租户隔离的localStorage
 */
import { getTenantContext } from './TenantContext';

// 租户前缀
function getTenantPrefix() {
  const { tenantId, userId } = getTenantContext();
  return tenantId + ':' + userId + ':';
}

function getItem(key: string) {
  let value = localStorage.getItem(getTenantPrefix() + key);
  // TODO 过渡, 后面要删除
  if (value === null) {
    // 查老key
    const { tenantId } = getTenantContext();
    const prefix = tenantId + ':';

    value = localStorage.getItem(prefix + key);
    // 老key存在, 换成新key
    if (value !== null) {
      setItem(key, value);
      localStorage.removeItem(prefix + key);
    }
  }

  return value;
}

function setItem(key: string, value: string) {
  localStorage.setItem(getTenantPrefix() + key, value);
}

function removeItem(key: string) {
  localStorage.removeItem(getTenantPrefix() + key);
}

export default {
  getItem,
  setItem,
  removeItem
};
